/* eslint-disable react/prop-types */
import React from 'react';
import {
  formatDate, showTodayOrTomorrow, showDateOrDateRange, getPreferredFfmFromAPI
} from '../../../components/helper/utils';
import {
  formatSellableQuantity
} from '../../helpers/pod-fulfillment-utils';
import { IDS } from '../../../automationTestIds';

export const getPLPSpeedTemplate = ({ product, displayQuantity }) => {
  const optimalPodFulfillment = getPreferredFfmFromAPI(product?.fulfillment, false, false, true);
  const { deliveryDates, deliveryTimeline, totalCharge } = optimalPodFulfillment || {};
  const isDeliveryFree = totalCharge === 0;
  const { startDate, endDate } = deliveryDates || {};

  const isResiliencyScenario = !endDate && totalCharge === null;
  if (isResiliencyScenario) {
    // FFA resiliency, isInStock is already checked in previous conditions
    return <span className="sui-text-primary">Available</span>;
  }

  const formattedStartDate = startDate && formatDate(startDate, false);
  const formattedEndDate = endDate && formatDate(endDate, false);

  // Determine date text
  let dateText = '';
  if (endDate && startDate === endDate) {
    dateText = showTodayOrTomorrow(endDate, true, deliveryTimeline, formattedEndDate, false);
  } else {
    dateText = showDateOrDateRange({ formattedStartDate, formattedEndDate });
  }
  // show quantity only if > 0, already checked b2b from shipping-helper
  const showQuantity = displayQuantity > 0;
  const formattedQty = formatSellableQuantity(displayQuantity);

  const renderPipeSeparator = () => <span>{' | '}</span>;
  const renderAvailable = () => <span className="sui-text-primary">Available</span>;
  const renderQuantity = () => (
    <>
      <span className="sui-text-success" data-automation-id={IDS.QTY.deliveryQty}>{`${formattedQty} `}</span>
      <span className="sui-text-primary">available</span>
    </>
  );

  const renderDateDisplay = () => {
    if (!dateText) return null;
    return (
      <>
        {(isDeliveryFree || showQuantity) && renderPipeSeparator()}
        <span className="sui-text-primary" data-automation-id={IDS.ETA.deliveryETA}>{dateText}</span>
      </>
    );
  };
  // Show "Available" text if no date is available and not B2B or no quantity
  const showAvailableText = (!dateText && !showQuantity);
  const showPipeSeparator = isDeliveryFree && (showQuantity || showAvailableText);

  // sample format - Free | Today
  return (
    <>
      {isDeliveryFree && <span className="sui-text-success">Free</span>}
      {showPipeSeparator && renderPipeSeparator()}
      {showQuantity && renderQuantity()}
      {showAvailableText && renderAvailable()}
      {renderDateDisplay()}
    </>
  );
};